import DashboardView from "../DashboardView.vue";
import DashboardPage from "../Pages/DashboardPage.vue";

const routes = [
  {
    path: '/',
    component: DashboardView,
    children: [
      {
        path: '',
        name: 'dashboard',
        plan: ['ALL'],
        component: DashboardPage,
      },
    ]
  }
]

export default routes
